import { render, staticRenderFns } from "./PokemonList.vue?vue&type=template&id=0a0b21a6&"
import script from "./PokemonList.vue?vue&type=script&lang=js&"
export * from "./PokemonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports